import useTracking from "../useTracking";
import { useRun } from "../hocs/DiPageHoC";
import useActionResult from "../hooks/useActionResult";
import useActionError from "../hooks/useActionError";

function useFormActionWithCaptcha(formAction, { endOn, useHook, ...captchaConfig }) {
	const actionWithDi = useRun(formAction);
	const actionWithCaptcha = useHook(actionWithDi, captchaConfig);
	const [actionWithResult, { error, result, reset }] = useActionResult(actionWithCaptcha);
	const [trackableAction, isLoading] = useTracking(actionWithResult, endOn);
	return [
		useActionError(trackableAction), //
		{ error, result, isLoading, reset }, //
	];
}

export default useFormActionWithCaptcha;
